import {
  Home as HomeIcon,
  User as UserIcon,
  Repeat as RepeatIcon,
  DollarSign as DollarSignIcon,
  ArrowDownCircle as ArrowDownCircleIcon,
  Settings as SettingsIcon,
  ShoppingCart as ShoppingCartIcon,
  File as FileIcon,
} from 'react-feather'

const ITEMS = [
  { title: 'Início', icon: <HomeIcon size={16} />, href: '/home' },
  { title: 'Clientes', icon: <UserIcon size={16} />, href: '/accounts' },
  {
    title: 'Chargebacks',
    icon: <RepeatIcon size={16} />,
    href: '/chargebacks',
  },
  {
    title: 'Tabela de preços',
    icon: <DollarSignIcon size={16} />,
    href: '/price-tables',
  },
  {
    title: 'Transações',
    icon: <ShoppingCartIcon size={16} />,
    href: '/orders',
  },
  {
    title: 'Saques',
    icon: <ArrowDownCircleIcon size={16} />,
    href: '/withdraws',
  },
  {
    title: 'Relatórios',
    icon: <FileIcon size={16} />,
    href: '/reports',
  },
  {
    title: 'Configurações',
    icon: <SettingsIcon size={16} />,
    href: '/settings',
  },
]

const menu = {
  ITEMS,
}

export default menu
